const storageKeys = {
    accountPreference: "accountPreference"
};
const cookieKeys = {
    authorization: "auth",
    accessToken: "access",
    refresh: "refresh"
};
const storeModule = {
    install(app) {
        app.config.globalProperties.$store = this;
    },

    clear() {
        Object.keys(storageKeys).forEach((key) => localStorage.removeItem(storageKeys[key]));
        Object.values(cookieKeys).forEach((value) => this.deleteCookie(value));
    },
    // getter
    getRefreshToken() {
        return this.getCookieValue(cookieKeys.refresh);
    },
    getAccountPreference() {
        let val = localStorage.getItem(storageKeys.accountPreference);
        return JSON.parse(val);
    },
    getAccountId() {
        return this.getAccountPreference()?.accountId;
    },
    getDefaultWorkspaceId() {
        return this.getAccountPreference()?.defaultWsId;
    },
    getLocale() {
        return this.getAccountPreference()?.locale || "it";
    },
    getMfaPreference() {
        return {
            "SOFTWARE_TOKEN_MFA": {
                "enabledDate": this.getAccountPreference().softwareTokenEnabledDate,
                "deviceName": this.getAccountPreference().softwareTokenDeviceName
            }
        }
    },
    getCookieValue(name) {
        return document.cookie
            .split("; ")
            .find((row) => row.startsWith(`${name}=`))
            ?.split("=")[1];
    },
    getFilter(key) {
        return JSON.parse(localStorage.getItem(`filter_${key}`));
    },
    getSorts(key) {
        return JSON.parse(localStorage.getItem(`sorts_${key}`));
    },
    isGrid(key) {
        return JSON.parse(localStorage.getItem(`isGrid_${key}`));
    },

    // setter
    setTokens(id, access, refresh) {
        this.setCookie(cookieKeys.authorization, id, 1);
        this.setCookie(cookieKeys.accessToken, access, 1)
        this.setCookie(cookieKeys.refresh, refresh, 60);
    },
    setAccountPreference(accountPreference) {
        localStorage.setItem(
            storageKeys.accountPreference,
            accountPreference == null ? "null" : JSON.stringify(accountPreference)
        );
    },
    setCookie(name, value, days) {
        let cookieValues = [];
        cookieValues.push(`${name}=${value}`);

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            cookieValues.push(`expires=${date.toUTCString()}`);
        } else {
            cookieValues.push(`expires=`);
        }

        cookieValues.push(`domain=${process.env.VUE_APP_DOMAIN}`);
        cookieValues.push(`path=/`);
        cookieValues.push("SameSite=strict");
        cookieValues.push("Secure");
        document.cookie = cookieValues.join(";");
    },
    setFilter(key, filter) {
        localStorage.setItem(`filter_${key}`, filter == null ? "null" : JSON.stringify(filter));
    },
    deleteCookie(name) {
        this.setCookie(name, null, -1);
    },
    setSorts(sortKey, sorts) {
        localStorage.setItem(`sorts_${sortKey}`, sorts == null ? "null" : JSON.stringify(sorts));
    },
    setGrid(key, isGrid) {
        localStorage.setItem(`isGrid_${key}`, JSON.stringify(isGrid));
    }
};
export default storeModule;
